'use client';
import React, { useState } from 'react';
import Badge from '@/components/ui/Badge';
import { MapPin, Clock, User, PoundSterling, ChevronRight, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import JobDetailModal, { JobDetail } from './JobDetailModal';

type KanbanStatus = 'pending' | 'assigned' | 'inprogress' | 'completed' | 'cancelled';

const initialJobs: JobDetail[] = [
{
  id: 'kj-001',
  service: 'Deep Clean',
  address: '142 Maple St, London, E1 6RF',
  customer: 'Sarah Mitchell',
  customerPhone: '+44 7700 900123',
  customerEmail: 'sarah.mitchell@email.com',
  date: 'May 17',
  time: '9:00 AM',
  status: 'inprogress',
  cleaners: ['Maria Gonzalez'],
  price: 189,
  payout: 112,
  bedrooms: 3,
  bathrooms: 2,
  description: 'Full deep clean required throughout the property. Please pay special attention to the kitchen appliances, bathroom grout, and skirting boards. Customer has two cats — please be mindful of pet hair.',
  customerPhotos: [
  { url: "https://img.rocket.new/generatedImages/rocket_gen_img_16bd997d6-1772301805315.png", alt: 'Kitchen before cleaning showing dirty countertops and appliances' },
  { url: "https://img.rocket.new/generatedImages/rocket_gen_img_1191b291c-1772301804417.png", alt: 'Bathroom before cleaning with soap scum on tiles' }],

  cleanerPhotos: [
  { url: "https://img.rocket.new/generatedImages/rocket_gen_img_1677b8282-1772132318153.png", alt: 'Kitchen after cleaning with sparkling countertops', uploadedBy: 'Maria Gonzalez' }]

},
{
  id: 'kj-002',
  service: 'Standard Clean',
  address: '87 Riverside Dr, London, SE1 7PB',
  customer: 'Tom Nguyen',
  customerPhone: '+44 7700 900456',
  customerEmail: 'tom.nguyen@email.com',
  date: 'May 17',
  time: '2:30 PM',
  status: 'assigned',
  cleaners: ['Marcus Johnson'],
  price: 119,
  payout: 70,
  bedrooms: 2,
  bathrooms: 1,
  description: 'Regular standard clean. Focus on living room, kitchen, and bathroom. Customer will be home during the clean.',
  customerPhotos: [],
  cleanerPhotos: []
},
{
  id: 'kj-003',
  service: 'Move-Out Clean',
  address: '502 Lake View, London, W2 3HT',
  customer: 'Elena Vasquez',
  customerPhone: '+44 7700 900789',
  customerEmail: 'elena.vasquez@email.com',
  date: 'May 18',
  time: '10:00 AM',
  status: 'pending',
  cleaners: [],
  price: 249,
  payout: 148,
  bedrooms: 3,
  bathrooms: 2,
  description: 'Full move-out clean for end of tenancy. Property must be left in pristine condition for landlord inspection. Includes oven clean, window cleaning inside, and carpet vacuuming.',
  customerPhotos: [
  { url: "https://img.rocket.new/generatedImages/rocket_gen_img_13c2fb53a-1772551715329.png", alt: 'Living room before move-out clean with furniture marks on carpet' }],

  cleanerPhotos: []
},
{
  id: 'kj-004',
  service: 'Standard Clean',
  address: '305 Oak Lane, London, N1 9GH',
  customer: 'James Okafor',
  customerPhone: '+44 7700 900321',
  customerEmail: 'james.okafor@email.com',
  date: 'May 19',
  time: '10:00 AM',
  status: 'pending',
  cleaners: [],
  price: 119,
  payout: 70,
  bedrooms: 2,
  bathrooms: 1,
  description: 'Standard weekly clean. Customer prefers eco-friendly cleaning products only. Key will be left under the mat.',
  customerPhotos: [],
  cleanerPhotos: []
},
{
  id: 'kj-005',
  service: 'Standard Clean',
  address: '23 Pine Ave, London, SW4 6LM',
  customer: 'Priya Sharma',
  customerPhone: '+44 7700 900654',
  customerEmail: 'priya.sharma@email.com',
  date: 'May 16',
  time: '9:00 AM',
  status: 'completed',
  cleaners: ['Devon Richards'],
  price: 119,
  payout: 70,
  bedrooms: 2,
  bathrooms: 1,
  description: 'Standard fortnightly clean. All rooms to be hoovered and surfaces wiped down.',
  customerPhotos: [],
  cleanerPhotos: [
  { url: "https://images.unsplash.com/photo-1722152749977-6d01092f2c1a", alt: 'Clean bathroom with fresh towels after completion', uploadedBy: 'Devon Richards' },
  { url: "https://img.rocket.new/generatedImages/rocket_gen_img_19371919f-1772187239009.png", alt: 'Spotless kitchen after standard clean', uploadedBy: 'Devon Richards' }]

},
{
  id: 'kj-006',
  service: 'Deep Clean',
  address: '99 Cedar Blvd, London, EC2A 4NE',
  customer: 'Rachel Kim',
  customerPhone: '+44 7700 900987',
  customerEmail: 'rachel.kim@email.com',
  date: 'May 16',
  time: '11:00 AM',
  status: 'completed',
  cleaners: ['Maria Gonzalez'],
  price: 189,
  payout: 112,
  bedrooms: 3,
  bathrooms: 2,
  description: 'Deep clean after renovation work. Lots of dust and debris. Please bring extra cloths and mop heads.',
  customerPhotos: [
  { url: "https://img.rocket.new/generatedImages/rocket_gen_img_1c58e2518-1772301808892.png", alt: 'Bedroom with dust and renovation debris before cleaning' }],

  cleanerPhotos: [
  { url: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6cfd59f-1772102979529.png", alt: 'Renovated bedroom cleaned and dust-free after deep clean', uploadedBy: 'Maria Gonzalez' }]

},
{
  id: 'kj-007',
  service: 'Standard Clean',
  address: '77 Birch Court, London, SE5 8QR',
  customer: 'Marcus Webb',
  customerPhone: '+44 7700 900111',
  customerEmail: 'marcus.webb@email.com',
  date: 'May 20',
  time: '9:00 AM',
  status: 'pending',
  cleaners: [],
  price: 119,
  payout: 70,
  bedrooms: 2,
  bathrooms: 1,
  description: 'Standard clean. Customer requests particular attention to the kitchen and bathroom. Has a dog — please ensure all doors are kept closed.',
  customerPhotos: [],
  cleanerPhotos: []
}];


const columns: {id: KanbanStatus;label: string;color: string;}[] = [
{ id: 'pending', label: 'Pending', color: 'border-warning/40 bg-warning-bg/30' },
{ id: 'assigned', label: 'Assigned', color: 'border-info/40 bg-info-bg/30' },
{ id: 'inprogress', label: 'In Progress', color: 'border-primary/40 bg-primary/5' },
{ id: 'completed', label: 'Completed', color: 'border-success/40 bg-success-bg/30' },
{ id: 'cancelled', label: 'Cancelled', color: 'border-border bg-muted/20' }];


const availableCleaners = [
{ id: 'cl-001', name: 'Maria Gonzalez', payoutRate: 15 },
{ id: 'cl-002', name: 'Marcus Johnson', payoutRate: 14 },
{ id: 'cl-003', name: 'Devon Richards', payoutRate: 13 },
{ id: 'cl-004', name: 'Aisha Patel', payoutRate: 13 },
{ id: 'cl-005', name: 'Carlos Mendez', payoutRate: 12 }];


const statusVariantMap: Record<KanbanStatus, 'pending' | 'assigned' | 'inprogress' | 'completed' | 'cancelled'> = {
  pending: 'pending',
  assigned: 'assigned',
  inprogress: 'inprogress',
  completed: 'completed',
  cancelled: 'cancelled'
};

export default function AdminKanban() {
  const [jobs, setJobs] = useState<JobDetail[]>(initialJobs);
  const [selectedJob, setSelectedJob] = useState<JobDetail | null>(null);

  const handleUpdateJob = (updatedJob: JobDetail) => {
    setJobs((prev) => prev.map((j) => j.id === updatedJob.id ? updatedJob : j));
    setSelectedJob(updatedJob);
    toast.success('Job updated successfully');
  };

  const moveJob = (e: React.MouseEvent, jobId: string, newStatus: KanbanStatus) => {
    e.stopPropagation();
    setJobs((prev) => prev.map((j) => j.id === jobId ? { ...j, status: newStatus } : j));
    toast.success(`Job moved to ${newStatus}`);
  };

  const cancelJob = (e: React.MouseEvent, jobId: string) => {
    e.stopPropagation();
    setJobs((prev) => prev.map((j) => j.id === jobId ? { ...j, status: 'cancelled' } : j));
    toast.success('Job cancelled');
  };

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 overflow-x-auto">
        {columns.map((col) => {
          const colJobs = jobs.filter((j) => j.status === col.id);
          return (
            <div key={`col-${col.id}`} className={`rounded-2xl border ${col.color} p-3 min-h-[400px]`}>
              <div className="flex items-center justify-between mb-3 px-1">
                <div className="flex items-center gap-2">
                  <Badge variant={statusVariantMap[col.id]} label={col.label} size="sm" />
                  <span className="text-xs font-bold text-muted-foreground">{colJobs.length}</span>
                </div>
              </div>
              <div className="space-y-2">
                {colJobs.map((job) =>
                <div
                  key={job.id}
                  onClick={() => setSelectedJob(job)}
                  className="bg-card rounded-xl border border-border p-3 card-shadow hover:card-shadow-lg transition-all duration-150 cursor-pointer group">
                  
                    <div className="flex items-start justify-between mb-2">
                      <p className="text-xs font-bold text-foreground">{job.service}</p>
                      <ChevronRight size={12} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
                    </div>
                    <div className="space-y-1.5 text-xs text-muted-foreground">
                      <div className="flex items-center gap-1.5">
                        <MapPin size={10} className="flex-shrink-0" />
                        <span className="truncate">{job.address.split(',')[0]}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <Clock size={10} className="flex-shrink-0" />
                        <span>{job.date} · {job.time}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <User size={10} className="flex-shrink-0" />
                        {job.cleaners.length === 0 ?
                      <span className="text-danger font-semibold">Unassigned</span> :
                      job.cleaners.length === 1 ?
                      <span className="truncate">{job.cleaners[0]}</span> :

                      <span className="text-primary font-semibold">{job.cleaners.length} cleaners</span>
                      }
                      </div>
                      <div className="flex items-center justify-between pt-1 border-t border-border mt-1">
                        <span className="flex items-center gap-0.5">
                          <PoundSterling size={10} />{job.price} customer
                        </span>
                        <span className="text-success font-semibold">£{job.payout} payout</span>
                      </div>
                    </div>
                    {/* Quick Actions */}
                    <div className="mt-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      {job.status === 'assigned' &&
                    <button
                      onClick={(e) => moveJob(e, job.id, 'inprogress')}
                      className="flex-1 py-1 rounded-lg bg-primary/10 text-primary text-xs font-semibold hover:bg-primary/20 transition-colors">
                      
                          Mark In Progress
                        </button>
                    }
                      {job.status === 'inprogress' &&
                    <button
                      onClick={(e) => moveJob(e, job.id, 'completed')}
                      className="flex-1 py-1 rounded-lg bg-success-bg text-success text-xs font-semibold hover:bg-success/20 transition-colors">
                      
                          Mark Complete
                        </button>
                    }
                      {(job.status === 'pending' || job.status === 'assigned') &&
                    <button
                      onClick={(e) => {e.stopPropagation();setSelectedJob(job);}}
                      className="flex-1 py-1 rounded-lg bg-primary text-white text-xs font-semibold hover:opacity-90 active:scale-95 transition-all">
                      
                          {job.cleaners.length === 0 ? 'Assign' : 'Manage'}
                        </button>
                    }
                      {job.status !== 'completed' && job.status !== 'cancelled' &&
                    <button
                      onClick={(e) => cancelJob(e, job.id)}
                      className="py-1 px-2 rounded-lg bg-danger/10 text-danger text-xs font-semibold hover:bg-danger/20 transition-colors flex items-center gap-1">
                      <XCircle size={10} />
                          Cancel
                        </button>
                    }
                    </div>
                  </div>
                )}
                {colJobs.length === 0 &&
                <div className="py-8 text-center text-xs text-muted-foreground">
                    No {col.label.toLowerCase()} jobs
                  </div>
                }
              </div>
            </div>);

        })}
      </div>

      <JobDetailModal
        job={selectedJob}
        onClose={() => setSelectedJob(null)}
        onUpdateJob={handleUpdateJob}
        availableCleaners={availableCleaners} />
      
    </>);

}